<template>
  <div class="translate-ebook-page">
    <!-- Hero区域 -->
    <EbookHeroSection />

    <!-- 电子书翻译功能区域 -->
    <section class="translation-section">
      <div class="section-container">
        <CategoryTranslationForm
          category="ebook"
          @start-translation="handleStartTranslation"
        />
      </div>
    </section>

    <!-- SEO内容区域 -->
    <EbookSeoContent />
  </div>
</template>

<script setup lang="ts">
// 导入电子书相关组件
import EbookHeroSection from '~/components/ebook/EbookHeroSection.vue'
import EbookSeoContent from '~/components/ebook/EbookSeoContent.vue'
import CategoryTranslationForm from '~/components/shared/CategoryTranslationForm.vue'

// 设置页面标题和meta信息
const { t } = useI18n()
useWebsiteSeo({
  title: () => t('seo.category.ebook.title'),
  description: () => t('seo.category.ebook.desc')
})

// 处理翻译请求
const handleStartTranslation = (settings: any) => {
  console.log('电子书翻译页面接收到翻译请求:', settings)
  // TODO: 第二阶段实现实际翻译功能
}
</script>

<style scoped lang="scss">
@use 'sass:color';

.translate-ebook-page {
  min-height: 100vh;
  background: $white;
}

// 翻译功能区域
.translation-section {
  padding: $spacing-xxl 0;
  background: linear-gradient(135deg,
    rgba(#4A90E2, 0.08) 0%,
    rgba(#FF8C42, 0.05) 25%,
    rgba(#52C41A, 0.08) 50%,
    rgba(#FF8C42, 0.05) 75%,
    rgba(#4A90E2, 0.08) 100%);
  position: relative;

  .section-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 $spacing-lg;
  }
}


// 响应式设计
@media (max-width: 768px) {
  .translation-section {
    padding: $spacing-xl 0;

    .section-container {
      padding: 0 $spacing-md;
    }
  }
}
</style>
